module.exports = __webpack_public_path__ + "static/media/Poppins-Regular-latin.9212f6f9.woff2";